import { Observable } from 'rxjs/Observable'

import { ModelRepositoryAdapter, BaseModel, ApiError, HttpStatus } from '../../'
import { ModelFactory } from '../../../data/factories'
import { IModelRepositoryAdapter } from '../'

export class GuaranteedFindDecorator<T extends BaseModel>  implements IModelRepositoryAdapter<T> {
  public constructor(
    private _service: ModelRepositoryAdapter<T>,
    private _modelFactory: ModelFactory,
    private _httpStatus: HttpStatus
  ) {}

  public findModelById(id: string, includeRelations: string[] = [], args?: {}): Observable<T> {
    return this._matchesIdFormat(id) ?
      this._addCatchObservable(this._service.findModelById(id, includeRelations)) :
      this._getNullObjectObservable(args)
  }

  public findAllModels(includeRelations: string[] = []): Observable<T[]> {
    // TODO [GitHub Issue]: need to write graranteed logic
    return this._service.findAllModels(includeRelations)
  }

  public findModelsBy(searchCriteria: any, includeRelations: string[] = [], args?: {}): Observable<T|T[]> {
    return this._addCatchObservable(this._service.findModelsBy(searchCriteria, includeRelations))
      .map((result) => Array.isArray(result) ? result : [result])
      .map((result: T[]) => result.length > 0 ? result : [this._getNullObject(args)])
  }

  public save(model: T): Observable<T> {
    return this._service.save(model)
  }

  public delete(model: T): Observable<boolean> {
    return this._service.delete(model)
  }

  private _getNullObjectObservable(args?: {}) {
    return Observable.of(this._getNullObject(args))
  }

  private _getNullObject(args?: {}) {
    return this._modelFactory.getNullObject(
      this._service.modelType.name,
      args
    ) as T
  }

  private _addCatchObservable(observable: Observable<T|T[]>) {
    return observable
      .catch((error: ApiError) => {
        if (error.code === this._httpStatus.NOT_FOUND.toString()) {
          return this._getNullObjectObservable()
        }
        return Observable.throw(error)
      })
  }

  private _matchesIdFormat(id: string): boolean {
    return parseInt(id, 10) > 0
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/model-repository/guaranteed-find/guaranteed-find.decorator.ts